import { promiseUtils } from '~/utils/promise'

/**
 * @description Detects when Safari/IE/Edge/Chrome autofill is triggered without requiring user input.  Not needed on Firefox.
 * @description This solution is based on a delightfully helpful post (probably the only one on the entire internet) by this kind soul at: https://medium.com/weekly-webtips/detecting-chrome-autofill-on-page-load-78ea178e4a68
 * @param element
 */
export const detectAutofillAsync = async (
  element: HTMLInputElement,
  delayMs: number = 600,
) => {
  await promiseUtils.delay(delayMs)
  if (!element) return false
  return (
    window.getComputedStyle(element, null).getPropertyValue('appearance') ===
    'menulist-button'
  )
}
